import { BaseDto } from './base.dto';

export class ItemDiscountDto extends BaseDto {
  orderItemId: number;
  discountId: number;
  amount: number;
}
